import styled from "styled-components";

import { Modal } from "../../atoms/Modal";
import { Button } from "../../atoms/Button";
import { Typography } from "../../atoms/Typography";

const StyledModal = styled(Modal).withConfig({
  shouldForwardProp: (prop) => {
    return prop === "isOpen" || prop === "children";
  },
})`
  overflow: visible;
`;

const ModalContainer = styled.div`
  min-width: 480px;
  display: flex;
  flex-direction: column;
  min-height: 300px;
  position: relative;
`;

const Container = styled.div`
  width: 100%;
  padding: 0 15px;
  display: flex;
  flex-direction: column;
  align-items: start;
`;

const TitleWrapper = styled.div`
  margin: 60px 0 20px 0;
  width: 100%;
  text-align: center;
  line-height: 28px;
  white-space: nowrap;
`;

const ButtonWrapper = styled.div`
  padding: 0 20px;
  display: flex;
  width: 100%;
  height: 44px;
  margin-bottom: 40px;
  button {
    margin-right: 20px;
  }
  button:last-child {
    margin-right: 0;
  }
`;

const InputWrapper = styled.div`
  width: 100%;
  padding: 0 20px;
  margin: 30px 0 50px 0;
  display: flex;
  justify-content: center;
`;

type Props = {
  isOpen?: boolean;
  title?: string;
  value?: string;
  isLoading?: boolean;
  onCancelClick: () => void;
  onPublishClick: () => void;
};

export const ConfirmVerifyCodeModal = ({
  isOpen,
  title,
  value,
  isLoading,
  onCancelClick,
  onPublishClick,
}: Props) => {
  return (
    <StyledModal isOpen={isOpen}>
      <ModalContainer>
        <Container>
          <TitleWrapper>
            <Typography size={4} bold>
              {title || ""}
            </Typography>
          </TitleWrapper>
          <InputWrapper>
            <Typography size={2} bold>
              {value}
            </Typography>
          </InputWrapper>
          <ButtonWrapper>
            <Button onClick={onCancelClick} disabled={isLoading}>
              <Typography size={2} bold>
                {"キャンセル"}
              </Typography>
            </Button>
            <Button
              buttonType={"primary"}
              onClick={onPublishClick}
              disabled={isLoading}
            >
              <Typography size={2} bold>
                {"発行"}
              </Typography>
            </Button>
          </ButtonWrapper>
        </Container>
      </ModalContainer>
    </StyledModal>
  );
};
